module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [(_vm.sharedWarehouseNotice) ? _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "left",
      "border": "1px solid #e84c4c",
      "background": "#F56C6C",
      "color": "#fff",
      "font-size": "16px",
      "margin-bottom": "30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.sharedWarehouseNotice)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.productParentId) ? _c('el-breadcrumb', {
    staticClass: "margin-b-10",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'products.edit',
        params: {
          id: _vm.product.productParentId
        },
      }
    }
  }, [_vm._v(_vm._s(_vm.product.productParentName))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.product.name))])], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.products.edit.title')))]) : _c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.product.name))])], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.products.formTabs.productInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkHasInventory),
      expression: "checkHasInventory"
    }],
    attrs: {
      "xs": 24,
      "md": 24,
      "lg": 24
    }
  }, [(_vm.productType && _vm.checkHasInventory && +_vm.productType.stockable !== 0) ? _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.customSkuform,
      "label-width": "180px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.customSkuform.custom_sk_error,
      "label": _vm.$t('form.products.sku.label')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": (_vm.customSkuform.custom_sku && _vm.customSkuform.update_sku === false) ? true : false,
      "placeholder": "Please input"
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.customSkuKeydown($event)
      }
    },
    model: {
      value: (_vm.customSkuform.custom_sku),
      callback: function($$v) {
        _vm.$set(_vm.customSkuform, "custom_sku", $$v)
      },
      expression: "customSkuform.custom_sku"
    }
  })], 1), _vm._v(" "), (!_vm.account.hasPartner) ? [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('form.products.updateSku.label')
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.customSkuform.update_sku),
      callback: function($$v) {
        _vm.$set(_vm.customSkuform, "update_sku", $$v)
      },
      expression: "customSkuform.update_sku"
    }
  })], 1), _vm._v(" "), (_vm.customSkuform.update_sku === true && !_vm.hasSkuInitial) ? _c('el-form-item', {
    attrs: {
      "label": 'With sku initial?'
    }
  }, [_c('el-checkbox', {
    on: {
      "change": function($event) {
        return _vm.addSkuInitial($event)
      }
    },
    model: {
      value: (_vm.customSkuform.sku_initial),
      callback: function($$v) {
        _vm.$set(_vm.customSkuform, "sku_initial", $$v)
      },
      expression: "customSkuform.sku_initial"
    }
  })], 1) : _vm._e()] : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.products",
      "hasLabel": true
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-tabs', {
    staticClass: "product-tabs",
    attrs: {
      "stretch": "",
      "value": "productInformation"
    }
  }, [_vm._l((_vm.forms), function(newform) {
    return [((newform.name != 'lokalbrygg' && newform.name != 'onlineStore') || (newform.name == 'onlineStore' && _vm.hasWooModule === true)) ? _c('el-tab-pane', {
      key: newform.name,
      attrs: {
        "name": newform.name
      }
    }, [_c('span', {
      class: {
        'has-error': newform.form.errors.any()
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [(newform.form.errors.any()) ? _c('i', {
      staticClass: "el-icon-warning"
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(("static.products.labels." + (newform.name)))))]), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('v-form', {
      attrs: {
        "form": newform.form,
        "translation": "form.products",
        "hasLabel": true,
        "information": newform.information,
        "imageRemove": _vm.onImageRemove
      }
    }), _vm._v(" "), (newform.name === 'marketplace') ? _c('v-marketplace', {
      attrs: {
        "disabled": !_vm.showMarketplaceForm,
        "product": _vm.product,
        "data": _vm.marketplaceData
      },
      on: {
        "update": function($event) {
          _vm.marketplaceData = $event;
        },
        "priceUpdate": _vm.marketplacePriceUpdated
      }
    }) : _vm._e()], 1)], 1) : _vm._e()]
  })], 2)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.products.formTabs.inventory'),
      "name": "2"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-table', {
    attrs: {
      "list": _vm.warehouseList,
      "noDataMessage": _vm.$t('static.products.warehouse.noDataMsg'),
      "link": _vm.link,
      "linkKey": "name",
      "rowKey": "id",
      "translation": "static.products.warehouse.table"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.products.formTabs.transactions'),
      "name": "3"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 1,
      "lg": 1,
      "xl": 1
    }
  }, [_c('label', [_vm._v("Filter: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 3,
      "lg": 3,
      "xl": 3
    }
  }, [(_vm.hasProduction) ? _c('el-select', {
    staticClass: "el-col-24",
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "size": "medium",
      "placeholder": "Batch",
      "remote-method": _vm.getFilterBatches,
      "loading": _vm.batchFilter.loading
    },
    on: {
      "change": function($event) {
        return _vm.eventBatchFilter($event)
      },
      "clear": _vm.clearBatchFilter,
      "focus": _vm.focusBatchFilter
    },
    model: {
      value: (_vm.batchFilter.value),
      callback: function($$v) {
        _vm.$set(_vm.batchFilter, "value", $$v)
      },
      expression: "batchFilter.value"
    }
  }, _vm._l((_vm.batchFilter.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 3,
      "lg": 3,
      "xl": 3
    }
  }, [_c('el-select', {
    staticClass: "el-col-24",
    attrs: {
      "remote-method": _vm.getFilterWarehouse,
      "loading": _vm.warehouseFilter.loading,
      "filterable": "",
      "remote": "",
      "clearable": "",
      "size": "medium",
      "placeholder": "Warehouse"
    },
    on: {
      "change": function($event) {
        return _vm.eventWarehouseFilter($event)
      },
      "clear": _vm.clearWarehouseFilter,
      "focus": _vm.focusWarehouseFilter
    },
    model: {
      value: (_vm.warehouseFilter.value),
      callback: function($$v) {
        _vm.$set(_vm.warehouseFilter, "value", $$v)
      },
      expression: "warehouseFilter.value"
    }
  }, _vm._l((_vm.warehouseFilter.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.transactionLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.transactionLoading),
      expression: "transactionLoading"
    }]
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.transactionLoading && _vm.transactionListNew && _vm.transactionListNew.length < 1) ? _c('div', {
    staticClass: "whiteWrapper full-w flex justify-center",
    staticStyle: {
      "padding": "50px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('static.warehouse.transactions.noDataMsg')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.transactionListNew && _vm.transactionListNew.length > 0 && !_vm.transactionLoading) ? _c('v-table', {
    attrs: {
      "list": _vm.transactionListNew,
      "noDataMessage": _vm.$t('static.products.transactions.noDataMsg'),
      "link": _vm.transactionLink,
      "linkKey": "via",
      "rowKey": "id,key",
      "translation": "static.products.transactions.table"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.transactionListNew && _vm.transactionListNew.length > 0) ? _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.transactionsV2.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.sharedWarehouseNotice) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.products.formTabs.mergeProduct'),
      "name": "4"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.products.labels.mergeProduct')))]), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.productMergeForm,
      "translation": "form.products",
      "hasLabel": true
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.productMergeForm.loading
    },
    on: {
      "click": _vm.mergeProduct
    }
  }, [_vm._v(_vm._s(_vm.$t('button.merge').toUpperCase()))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Merging products with orders warehouse and stock record? Please contact the support.",
      "type": "info",
      "closable": false
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.sharedWarehouseNotice && _vm.product.childProducts && _vm.product.childProducts.length) ? _c('el-tab-pane', {
    attrs: {
      "label": ((_vm.$t('static.products.formTabs.childProducts')) + " (" + (_vm.product.childProducts.length) + ")"),
      "name": "5"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-table', {
    attrs: {
      "list": _vm.product.childProducts,
      "noDataMessage": _vm.$t('static.defaultText.product.noDataMsg'),
      "link": _vm.editProduct,
      "linkKey": "name",
      "rowKey": "id",
      "translation": "static.products.table"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('el-button', {
    staticClass: "outline danger",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.destroy
    }
  }, [_vm._v(_vm._s(_vm.$t('button.deleteProduct').toUpperCase()))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'products.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70d9bcae","hasScoped":false}!./src/app/pages/withNavigation/products/edit/edit.html
// module id = 3063
// module chunks = 1